<div class="wrapper mt-3 pb-6" [formGroup]="timesheetAndExpensesForm">
    <div class="row">
        <div class="col">
            @if (model) {
                <tabset type="pills" paceCoreTabsRole>
                    <tab
                        [heading]="strings.timesheetHeading"
                        [customClass]="isTimesheetFormInvalid() ? 'invalid-timesheet-expense-tab' : ''"
                    >
                        <pace-timesheet
                            [model]="model.timesheetEntries"
                            [readonly]="model.readonly"
                            [parentForm]="timesheetFormChildren"
                            (autoSaveTimesheetForm)="triggerAutoSaveTimesheet()"
                            [downloadInProgress]="downloadInProgress()"
                        ></pace-timesheet>
                    </tab>
                    @if (model?.expenses) {
                        <tab
                            [heading]="strings.expensesHeading"
                            [customClass]="isExpenseFormInvalid() ? 'invalid-timesheet-expense-tab' : ''"
                        >
                            <pace-expenses [model]="model" [parentForm]="expensesFormChildren"></pace-expenses>
                        </tab>
                    }
                </tabset>
            }
        </div>
    </div>
</div>

<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid d-flex flex-column">
        <ul class="navbar-nav d-flex d-lg-none flex-column mx-auto">
            @if (timesheetAndExpensesForm.invalid) {
                <li class="navbar-text">{{ strings.invalidTimesheetMessage }}</li>
            }
            @if (model?.readonly) {
                <li class="navbar-text">{{ strings.submittedTimesheetMessage }}</li>
            }
        </ul>

        <div class="d-flex align-items-center justify-content-between w-100">
            <ul class="navbar-nav d-none d-lg-flex flex-column mx-auto">
                @if (timesheetAndExpensesForm.invalid) {
                    <li class="navbar-text">
                        {{ strings.invalidTimesheetMessage }}
                    </li>
                }
                @if (model?.readonly) {
                    <li class="navbar-text">{{ strings.submittedTimesheetMessage }}</li>
                }
            </ul>
            <ul class="navbar-nav d-flex flex-row gap-3 ms-auto mb-3">
                <li class="nav-item">
                    <button
                        class="btn btn-primary"
                        type="button"
                        (click)="submit()"
                        [disabled]="isTimesheetSendDisabled()"
                        translate="TIMESHEET_SAVE_TIMESHEET_TITLE"
                    ></button>
                </li>
                <ng-template #statusButtonContent let-status="status" let-label="label">
                    @switch (status) {
                        @case (timesheetSyncStatus.LOADING) {
                            <fa-icon [icon]="faLoading" animation="spin"></fa-icon>
                        }
                        @case (timesheetSyncStatus.SUCCESS) {
                            {{ label }}
                            <fa-icon [icon]="faCheckCircle" class="text-success"></fa-icon>
                        }
                        @case (timesheetSyncStatus.ERROR) {
                            {{ label }}
                            <fa-icon [icon]="faExclamationTriangle" class="text-danger"></fa-icon>
                        }
                        @default {
                            {{ label }}
                        }
                    }
                </ng-template>
            </ul>
        </div>
    </div>
</nav>
